import { IconButton, IconButtonProps } from '@material-ui/core';
import React, { useContext } from 'react';
import styled from 'styled-components';
import MenuIcon from '@material-ui/icons/Menu';
import { ReactFC } from '../types';
import { ScreenContext } from 'navigation/screen-context';


export const HamburgerButtonMinimize: ReactFC = () => {
  const { setMinimized } = useContext(ScreenContext);
  return (<HamburgerButton onClick={() => setMinimized(v => !v)} />);
};

export const HamburgerButtonOpen: ReactFC = () => {
  const { setDrawerOpen } = useContext(ScreenContext);
  return (<HamburgerButton onClick={() => setDrawerOpen(v => !v)} />);
};
const HamburgerContainer = styled.div`
  flex: 1;
  max-width: ${({ theme }) => theme.leftNavSize - 2 * theme.spacing(2)}px;
  margin-right: ${({ theme }) => theme.spacing(2)}px;  
  ${({ theme }) => theme.breakpoints.up('sm')} {
    max-width: ${({ theme }) => theme.leftNavSize - 2 * theme.spacing(3)}px;
    margin-right: ${({ theme }) => theme.spacing(3)}px;    
  }

  & .MuiIconButton-edgeStart {
      margin-left: 0;
  }  

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HamburgerButton: ReactFC<IconButtonProps> = (props) => {
  return (
    <HamburgerContainer>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="start"
        {...props as any}
      >
        <MenuIcon />
      </IconButton>
    </HamburgerContainer>
  );
};
